import { Component } from '@angular/core';
import { ActivatedRoute, ActivationEnd, ActivationStart, NavigationEnd, Router } from '@angular/router';
import { AuthenticationCheckService } from './services/auth/authentication-check.service';
import { ApiConfiguration } from './services/http/api-configuration';
import { ApiService } from './services/http/api.service';
import { UploadZipService } from './services/upload-zip/upload-zip.service';
import { DataService } from './services/data/data.service';
import { DataLayerService } from './services/data-layer/data-layer.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isopenUploadBox = false;
  title = 'hubAdmin';
  uploadExcelDetails:any;
  token: any = String;
  uid: any = String;
  loaderConfig = {
    "bgsColor": "rgba(52,51,51,0.19)",
    "bgsOpacity": 0.5,
    "bgsPosition": "bottom-right",
    "bgsSize": 60,
    "bgsType": "ball-scale-multiple",
    "blur": 5,
    "delay": 0,
    "fastFadeOut": true,
    "fgsColor": "#007bff",
    "fgsPosition": "bottom-right",
    "fgsSize": 60,
    "fgsType": "square-jelly-box",
    "gap": 24,
    "logoPosition": "center-center",
    "logoSize": 120,
    "logoUrl": "",
    "masterLoaderId": "master",
    "overlayBorderRadius": "0",
    "overlayColor": "rgba(40, 40, 40, 0.8)",
    "pbColor": "#007bff",
    "pbDirection": "ltr",
    "pbThickness": 3,
    "hasProgressBar": true,
    "text": "",
    "textColor": "#FFFFFF",
    "textPosition": "center-center",
    "maxTime": -1,
    "minTime": 300
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private auth: AuthenticationCheckService,
    private dataService: DataService,
    private _dataLayerService: DataLayerService,
    ) {
      
      this.router.events.subscribe(event => { // subscribe to router events
        if (event instanceof NavigationEnd) 
        {
          this._dataLayerService.logPageView(event.url) //call our dataLayer service's page view method to ping home with the url value.
        }
      });
     //this.router.navigate(["catalogue/dashboard"]);

    this.activatedRoute.queryParams.subscribe(params => {
          if(params.query){
         //let param ="Bv2jCMK4y9CXU7dh++YCfRBzzXGYAZNmKFqeiPig7o07TWrn460dqOfwu59iUxTqnMe2c5oxcGqCIzqnqUZE/UccN1i56rNLLRFV7ABGilC7Itv80X3CS+o8FGa7jXlp0acgIwyS38zJ9rpgoPeCUodaH2JENJ/ZgpFGqzTwsYCUx9SSAjsvAJ78PMUjSxykA6ZlLiG4MtGItIqWWKMeTbWpMfYHA2jezmD+me7v18qJIqLKTIteF+iGjjz2/0dI2SZiJ8cn7hSSX0F3roUwRlQio6I3b2y6fRl2w6vFB7iQFmhTUO9385PYIzrXcGChkZNgl/CMCVbgPBfMHWuyYXbPNRwueZsxfHRvht1HXWbWZeWRl4odCFos4vbj8oP6O2X6SxQcZXN+T1yYcUwf2fw08jMrxiOCLACIxWJOvM13r9WtIvCNH0Ckr375njJqfmocsNY3C66VCXIMVtHPQ0eqsu/FaPP1sE39L77mzhAkoDqIZv8ZGn9ELDQua+F5IMyBKuR4KuqQuV+7UTajhtRCHoi9mIJ9f2epLH9me/bVtE6AtQiLXKnfsShaKxNekgbSHE4Bn35tvhdyH8FRTHeChEWp4BSEjUFECaETAJXlHN3N3gAginpLd2iZr7KzoZSG8MV6lj7s8soRIsl5m+QKhH0WhNbjuuBlsx2hZ7pGZ/zZF1C1kJdh4NgwbYi5EdEOt5u2A8WNFbgAIL0zcIEWGwauB/OvL2o5VEG2U5uWJ33ImkMpCresaaXcDWiREi1r6jAI2wYhCMYNquAIWurk9DALCDeUjkxittGU5nqiQJq+00YolHhoyZShsORq7wgD34Ipz7Ct96HatFuE16JQVikZ2XFHgEpDtkp/snAX8nEZAF+EnpBxzWcLzjZeup56W4B0LuDdUTA4p6p2EmB+r5GSGd8/d7zq7SMjVLhpJ4xO0fLMAl5B6zK/3lXt4hLdEmJQLlr+YWslon25LlyMQhssdZ77bpPXTy0qrGkEa8648YYN/tK2i3n4vnxlxWrQYOV+UvDVsNXDHdTzZdBgsacSFetwUHuzoPcKLnvHHR8ESqWRlpa2gwZ8l2+mWVcenVLwPmWe/sJ/8l4BhHV09RIy4eLYReTXFL5N+5yHqLHk6NpziVrZScQl4AfHlRaEnFrD+AR40alrfX1xpQjcp6mBTYLwxSvGOQYcxFJRsMEd5OHHjlASei+XTADGbb3iMM7A5qp4Ryd1UmNewjdj8MlesEvqoekYurX+4IezVFYyM9vLvB+D3yYhafKysQnS1mOt+jW93zp0z/UVdnl309DIg/x4zVP2PNgwtKH0BuBLAkoYB+IGyNWB5q14yTDbTiwFD5i45NE2OMpygS2WAiLhDFh15L6towXE8nNyfNsKqY2AHXXsIi+ZTJ2J21xkWIYv8jnvgYPVGXl8zhCKbgNpuQY8vE4AlLUz1YV8Y9O3uP78HileQmasAtHC/2athVRHzrSB057GsOx29Omd6O130UYapujk7wpewHxXrGjZOBkBVnH/tcWIWEfevzmebDqZgh70+feVLKTFFOasdyGFAPELFPwA7vCCJ2htYapSle9aenP5yfJXfUp4QH+o1gsQPVysy6/5O0KItbkx8agq1x4UcvMVntmtJFO4+d2RwZXu6enCOc6t8tMBPMUjbzn84A5+8nlrXHBk8LbAFnL71lujdEQNfcMa7w1ZjjSnxTxs2ZyaVVUO0h+BMiVswbBP/xCc130czJJ2dOc94yOdo7rShq21xi9Qilo9g/9UpOVMTXAaa+sThtPcPqq50odLgxkK5dVymKqUEBrOJjM5JCZGhz5NylExawUMyWfRIjpmSpWevCR8G8qJe0I3dBPW0++GsNBaAUo++tOlx1LnvddE7YCb/P6N9awAqRoQiT9iqqn4M/jWdvLLzx9JpvFGVkeR06y57HHDepridiHRgBFIhV3dLjk75mL0gE32Cd3yL5+KKSwqYPAmAoU3wtnhdpO2T7lknOIIRptY13sTyg1h/LSk/bAjv8b2hKxgtI58jd3vUgSALzyq1GHlSXvYi6fyltQ2qmlEbJddaKAyuCFk7RFSA8GriXW6QEPhhG9KeX1XmTBj+GDtwnK+Fk+VBLHX7FTRFQsk2j7zpTcI/+Hxb0HTtqLHeAG6wR2qfu118oITh3OtG6ITmGzocRnLnyCd1TDyJj+f2LFbxHLLzthBdNufnev1GXMcUpFgwXNENeQeRlY//Rw248fJpKaouVfstQAoEwgtAvElyMhx38kftjuGStgUS/2X86cbeVWWVbjMjkscIYkBJqCtaT6KwTyTzpCyPz3gj/oOtq7QL9M1PlwGXb3HWGpP/1hKf3a/cxSCnvNIg0/cvokZjWCNibZGlWYBOrjbombn8atDjRk0jsZEO3olPrsJDOtUXbNokR4c448UId6xk81MUtO2XUoBw55Jf7tyVeYuN0KYxRuVyqn/HnPPyJ5ZF/Ex+hmU+OCZYmAI7cwAWuJ/RKRWUeAUxPPdhFBzwQ3H1viOQoHUhQzes8d9zOiIvzyVSjmUmD0ozi0Y6EuIiplW++sgwgen/b5GAS7PvWrK1YxkeDZ37Ey2vkMfadiZxMBGAVEleg9SGcGHsvm2Q9SOkrN71F3vEJC+kKpC1BaVxOUNLLZmHHUERdB4iwALnr/BCRZRsfY79Cu1IimXkQUmxnNZTVSlBNxLPZ15X54WlhD6/jFcPzZHNK2AsktiXNEeJCwtxkis60YF0xgctzaiYth6HzfPzRdJpSLO1ffvDdvBKDEyBi7UGYpLjdxkc6qD973LxfuX5DYLswsNiSLIOXnG/Rzb2YQicRWx8HM7fWPFBjsY9fBTYpVH5KAuJa+sSJBdCY/VDv5bYvIGLLvSHchesobiUkpkxjkof6Z1iYzLQkn4OJvYKIMDanuZvZ2AuRyrI3776Zq8rxUWeJv9s4vH7Xqn5XewLe1KxKFVTse2Qy2Vnq779JMpHCEzp7Yptd9CN4N/PKZ15FuyOB01GXHPILjcc6SdZbIrbFOzKPoIYrOdNmXSeaH/SUHkIUaTP5ZM8VxT3P2taCZgl3MuiR6qTS2PcehVjk/qluJrpPAavBQ44bh55MGlUF6sHdttIpQ/UTEuwh4PVC77kUoRRiOGhWeGp3O/rMQC7kuEvfn81e0prtsmo1L0DOs="
         

 
         let param = params.query
            this.token = encodeURIComponent(param)
            this.getUserPoints()
          }

      });
  }

  getUserPoints(){

    this.apiService.get(this.apiConfig.getUserPoints +`?query=${this.token}`)
    .subscribe((res:any)=>{
      console.log(res)
      localStorage.setItem('login-details', JSON.stringify(res.data))
      localStorage.setItem('auth-token', res.data.uid)
      console.log(res.data.uid)
      this.updateBlancePoints(res.data.balance)
      this.auth.saveAuth(res.data.uid).then((resonse)=>{
        this.router.navigate(["catalogue/dashboard"]);
      })
      
    },err=>{
      console.log(err, 'asdsad')
    })
  }

  updateBlancePoints(points){
    this.dataService.changePointData(points)
 }
}
